import { CoreInputEditorType } from "../constants/dev-extreme-enums";
import { SellerSnapshotFieldGroup, SellerSnapshotFieldType } from "../constants/enums";

export class SellerSnapshotField {
    fieldKey: string;
    caption: string;
    type: SellerSnapshotFieldType;
    value: any;
    // Client-side only
    editorType: CoreInputEditorType;
    visible: boolean;
    group: SellerSnapshotFieldGroup;
    template: string;

    constructor(fieldKey: string, caption: string, type: SellerSnapshotFieldType, editorType: CoreInputEditorType, template: string) {
        this.fieldKey = fieldKey;
        this.caption = caption;
        this.type = type;
        this.editorType = editorType;
        this.template = template;
        this.visible = true;
    }
}
